import postApiCall from "./postApiCall";
export const LogoutApi =async(type)=>{
        try{
                // Remove only the first path segment (partner)
const redirectPath = window.location.pathname.replace(/^\/[^/]+/, "");
                
                 // Save current URL
    sessionStorage.setItem(
      "redirectAfterLogin",
      redirectPath + window.location.search
    );
 let response = await postApiCall("admin/logout", {logoutMode:type}, true);
        if(response.meta.status){
               
                return true
        }
        else{
                return false    
        }
}
catch(error){
        return false  
}
}